const WHATSAPP_NUMBER = '34666365922';
const WHATSAPP_MESSAGE = encodeURIComponent('Hola, me gustaría obtener más información sobre vuestros servicios.');

const WhatsAppButton = () => (
  <a
    href={`https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Contactar por WhatsApp"
    className="fixed bottom-24 right-6 z-50 flex items-center justify-center w-14 h-14 rounded-full shadow-lg transition-transform duration-300 hover:scale-110 active:scale-95"
    style={{ backgroundColor: '#25D366' }}
  >
    <i className="ri-whatsapp-line text-white text-3xl" />
  </a>
);

export default WhatsAppButton;
